<p-drawer
    [id]="id() + '-drawer'"
    [position]="position()"
    [styleClass]="(styleClass() || 'custom-drawer') + sizeWidth()"
    [modal]="modal()"
    [showCloseIcon]="showCloseIcon()"
    [blockScroll]="blockScroll()"
    [closeOnEscape]="closeOnEscape()"
    [(visible)]="isVisible"
    (onHide)="onHide.emit()">
    @let title$ = title();
    @if (title$ && title$.length) {
        <ng-template #header>
            <div>
                {{ title$ | translate }}
            </div>
        </ng-template>
    } @else {
        <ng-template #header>
            <ng-content select="[customHeader]"></ng-content>
        </ng-template>
    }

    <ng-content></ng-content>
</p-drawer>
